import {
  ADD_ADMIN_USER_ERROR,
  LOADING_ADD_ADMIN_USER,
  ADD_ADMIN_USER_SUCCESS,
  CLOSE_ADD_USER_DRAWER,
  CLOSE_EDIT_USER_DRAWER,
  CLOSE_USER_ROLE_DRAWER,
  EDIT_ADMIN_USER_SUCCESS,
  EMPTY_SELECTED_USER,
  EMPTY_USER,
  EMPTY_USERS,
  EMPTY_USER_ROLE,
  FETCH_ALL_PERMISSIONS_ERROR,
  FETCH_ALL_PERMISSIONS_SUCCESS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_PERMISSIONS_BY_USERID_ERROR,
  FETCH_PERMISSIONS_BY_USERID_SUCCESS,
  LOADING_EDIT_ADMIN_USER,
  OPEN_ADD_USER_DRAWER,
  OPEN_EDIT_USER_DRAWER,
  OPEN_USER_ROLE_DRAWER,
  REMOVE_SHOW_ERROR_MESSAGE,
  REMOVE_SHOW_SUCESS_MESSAGE,
  SELECT_USER,
} from "constants/ActionTypes";

const INIT_STATE = {
  users: [],
  selectedUser: {Nothing:""},
  emptyUser: true,
  emptyPermission: true,
  emptyUserRole: true,
  alertMessage: "",
  showErrorMessage: false,
  showSuccessMessage: false,
  loadingUsers: true,
  loadingPermissions: true,
  loadingAddUser: false,
  loadingEditUser: false,
  loadingUserRoles: true,
  permissions: [],
  openUserRoleDrawerState: false,
  openEditUserDrawerState: false,
  openAddUserDrawerState: false,
};

export default (state = INIT_STATE, action) => {
  // console.log({action})
  switch (action.type) {
    case FETCH_ALL_USERS_SUCCESS: {
      return {
        ...state,
        users: action.payload,
        emptyUser: false,
        loadingUsers: false,
      };
    }
    case EMPTY_USER: {
      return {
        ...state,
        emptyUser: true,
        alertMessage: "There are no Users presently",
        loadingUsers: false,
      };
    }
    case EMPTY_SELECTED_USER: {
      return {
        ...state,
        selectedUser: {},
        showErrorMessage: false,
        showSuccessMessage: false,
        loadingEditUser: false,
        alertMessage: ""
      };
    }
    case ADD_ADMIN_USER_SUCCESS: {
      return {
        ...state,
        users: [action.payload, ...state.users],
        loadingAddUser: false,
        showSuccessMessage: true,
        alertMessage: "user added successfully",
        showErrorMessage: false
      };
    }
    case EDIT_ADMIN_USER_SUCCESS: {
      // 
      const users = state.users.map((user) => (user.UserId === action.payload.UserId ? {
        UserId: action.payload.UserId,
        Email: action.payload.Email,
        IsActive: action.payload.IsActive,
        IsFirstLogin: action.payload.IsFirstLogin,
        Username: action.payload.Username,
        Fullname: action.payload.Fullname,
      }
        : user
      ));
      return {
        ...state,
        users,
        loadingEditUser: false,
        showSuccessMessage: true,
        alertMessage: "user updated successfully",
        selectedUser: action.payload,
        showErrorMessage: false
      };
    }
    case ADD_ADMIN_USER_ERROR: {
      return {
        ...state,
        loadingAddUser: false,
        alertMessage:
          action.payload === ""
            ? "An error occured in adding users"
            : action.payload,
      };
    }
    case FETCH_ALL_PERMISSIONS_SUCCESS: {
      return {
        ...state,
        permissions: action.payload,
        loadingPermissions: false,
        emptyPermission: false,
      };
    }
    case FETCH_ALL_PERMISSIONS_ERROR: {
      return {
        ...state,
        loadingPermissions: false,
        alertMessage:
          action.payload === ""
            ? "An error occured in fetching permissions"
            : action.payload,
      };
    }
    case SELECT_USER: {
      // debugger
      // console.log({ll:state.users.find((user) => user.UserId === action.payload)})
      return {
        ...state,
        selectedUser: state.users.find(
          (user) => user.UserId === action.payload
        ),
      };
    }
    case FETCH_PERMISSIONS_BY_USERID_SUCCESS: {
      // debugger
      return {
        ...state,
        selectedUser: {
          ...state.selectedUser,
          permissions: action.payload,
        },
        loadingUserRoles: false,
        emptyUserRole: false,
      };
    }
    case FETCH_PERMISSIONS_BY_USERID_ERROR: {
      return {
        ...state,
        loadingUserRoles: false,
        alertMessage:
          action.payload === ""
            ? "An error occured in fetching permissions"
            : action.payload,
      };
    }
    case EMPTY_USER_ROLE: {
      return {
        ...state,
        emptyUserRole: true,
        alertMessage: "There are no Roles Assigned to User",
        loadingUserRoles: false,
      };
    }
    case OPEN_USER_ROLE_DRAWER: {
      return {
        ...state,
        openUserRoleDrawerState: true,
      };
    }
    case CLOSE_USER_ROLE_DRAWER: {
      return {
        ...state,
        openUserRoleDrawerState: false,
      };
    }
    case OPEN_EDIT_USER_DRAWER: {
      return {
        ...state,
        openEditUserDrawerState: true,
      };
    }
    case CLOSE_EDIT_USER_DRAWER: {
      return {
        ...state,
        openEditUserDrawerState: false,
      };
    }
    case OPEN_ADD_USER_DRAWER: {
      return {
        ...state,
        openAddUserDrawerState: true,
      };
    }
    case CLOSE_ADD_USER_DRAWER: {
      return {
        ...state,
        openAddUserDrawerState: false,
      };
    }

    case LOADING_EDIT_ADMIN_USER:
      return {
        ...state,
        loadingEditUser: true
      }

    case REMOVE_SHOW_ERROR_MESSAGE: {
      return {
        ...state,
        alertMessage: "",
        showErrorMessage: false
      }
    }
    case REMOVE_SHOW_SUCESS_MESSAGE: {
      return {
        ...state,
        alertMessage: "",
        showSuccessMessage: false
      }
    }
    case EMPTY_USERS: {
      return INIT_STATE
    }

    case LOADING_ADD_ADMIN_USER: {
      return {
        ...state,
        loadingAddUser: true
      }
    }
    default:
      return state;
      
  }
};
